import React, { useState } from 'react';
import logo from './logo.svg';
import './App.css';
import { ATMCard } from 'atm-card-react';

const BankLogo = () => {
    return (
        <div
            style={{
            display: 'flex',
            alignItems: 'center',
            fontFamily: 'Arial',
            fontWeight: 800,
            fontSize: 28,
            color: '#61DAFB'
            }}><img src={logo} style={{ width: 64 }}/> ReactBank</div>
    )
}

function App() {
    const systems: string[] = ['mastercard','maestro','visa','americanexpress','jcb','dinersclub','mir'];
    const [system, setSystem] = React.useState<string>(systems[0]);

    const [number, setNumber] = useState<string>('');
    const [month, setMonth] = useState<number>(2);
    const [year, setYear] = useState<number>(22);
    const [holder, setHolder] = useState<string>('');
    const [cvv, setCvv] = useState<string>('');
  
    return (
        <div className="App">
            <h2 style={{ fontFamily: 'sans-serif' }}>
                <span
                    style={{
                        marginRight: 6,
                        color: 'teal'
                    }}>{'<ATMCard />'}</span>
                React Component
            </h2>
            <code 
                style={{ 
                    display: 'inline-block',
                    fontFamily: 'sans-serif',
                    padding: 12,
                    backgroundColor: '#eee',
                    borderRadius: 8,
                    marginBottom: 16,
                    fontWeight: 600
                }}>npm i atm-card-react</code>
            <p style={{ textAlign: 'center' }}>
                <select 
                    onChange={e => setSystem(e.target.value)}
                    style={{
                        fontSize: '1rem'
                    }}>
                    {systems.map((item, index) => <option key={index} value={item}>{item}</option>)}
                </select>
            </p>
            <div style={{ 
                display: 'flex',
                justifyContent: 'flex-start',
                overflow: 'auto',
                padding: 24,
                marginBottom: 16
            }}>
            <ATMCard
                className="mr-4"
                system={system}
                number={number}
                lifted
                bgImage="https://images.unsplash.com/photo-1519335337423-a3357c2cd12e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80"
                bankLogo={<BankLogo/>}
                month={month}
                year={year}
                onChange={(data: any) => {
                setNumber(data.number);
                setHolder(data.holder);
                setMonth(data.month);
                setYear(data.year);
                setCvv(data.cvv);
                }}
                holderName={holder}
                cvv={cvv}/>
            <ATMCard
                className="mr-4"
                system={system}
                number={number}
                lifted
                bgColor="#3d3d3d"
                dataColor="silver"
                bankLogo={<BankLogo/>}
                month={month}
                year={year}
                onChange={(data: any) => {
                setNumber(data.number);
                setHolder(data.holder);
                setMonth(data.month);
                setYear(data.year);
                setCvv(data.cvv);
                }}
                holderName={holder}
                cvv={cvv}/>
            <ATMCard
                system={system}
                number={number}
                className="mr-4"
                lifted
                bankLogo={<BankLogo/>}
                month={month}
                year={year}
                onChange={(data: any) => {
                    setNumber(data.number);
                    setHolder(data.holder);
                    setMonth(data.month);
                    setYear(data.year);
                    setCvv(data.cvv);
                }}
                holderName={holder}
                cvv={cvv}/>
            <ATMCard
                system={system}
                number={number}
                lifted
                bankLogo={<BankLogo/>}
                month={month}
                year={year}
                bgColor="silver"
                onChange={(data: any) => {
                    setNumber(data.number);
                    setHolder(data.holder);
                    setMonth(data.month);
                    setYear(data.year);
                    setCvv(data.cvv);
                }}
                holderName={holder}
                cvv={cvv}/>
            </div>
            
            
            <div style={{ marginBottom: 16 }}>
                <a className="link" href="https://github.com/Assenti/atm-card-react#usage" target="_blank">Usage example</a>
            </div>
            <a className="link" href="https://github.com/Assenti/atm-card-react" target="_blank">Github repo</a>
            <span className="link" style={{ margin: '0 4px' }}>•</span>
            <a className="link" href="https://www.npmjs.com/package/atm-card-react" target="_blank">npm package</a>
        </div>
    );
}

export default App;
